import { Navigate, Route, Routes } from 'react-router-dom';
import { WallRoute } from './routes/wall';
import { PocketRoute } from './routes/pocket';
import { DeskRoute } from './routes/desk';
import { CaptureRoute } from './routes/capture';
import { GalleryRoute } from './routes/gallery';
import { Ambient } from './components/shared/Ambient';
import { AuthGate } from './components/auth/AuthGate';
import { useDayState } from './hooks/useDayState';

export function App() {
  const dayState = useDayState();
  return (
    <>
      <Ambient dayState={dayState} />
      <div className="relative z-10 min-h-screen">
        <AuthGate>
          <Routes>
            <Route path="/" element={<Navigate to="/wall" replace />} />
            <Route path="/wall" element={<WallRoute />} />
            <Route path="/pocket" element={<PocketRoute />} />
            <Route path="/desk" element={<DeskRoute />} />
            <Route path="/capture" element={<CaptureRoute />} />
            <Route path="/gallery" element={<GalleryRoute />} />
            <Route path="*" element={<Navigate to="/wall" replace />} />
          </Routes>
        </AuthGate>
      </div>
    </>
  );
}
